var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { useState } from "react";
import { Motion, StaggeredMotion, spring } from "react-motion";
import { Button, ButtonGroup, UncontrolledTooltip } from 'reactstrap';
import Icon from "../Icon";
import props from 'prop-types';

import "./MenuSide.css";

var Component = React.Component;
var _ref = "_",
    noop = _ref.noop;

var MenuSide = function (_Component) {
  _inherits(MenuSide, _Component);

  function MenuSide(props) {
    _classCallCheck(this, MenuSide);

    var _this = _possibleConstructorReturn(this, (MenuSide.__proto__ || Object.getPrototypeOf(MenuSide)).call(this, props));

    _this.state = {
      active: false
    };

    _this._onClick = _this._onClick.bind(_this);
    return _this;
  }

  _createClass(MenuSide, [{
    key: "_onClick",
    value: function _onClick() {
      this.setState({
        active: !this.state.active
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var iconArrayOne = [this.props.textOne];
      var iconArrayTwo = [this.props.textTwo];
      var tooltipArrayOne = [this.props.textTooOne];
      var tooltipArrayTwo = [this.props.textTooTwo];

      return React.createElement(
        "div",
        { id: "containerOf" },
        React.createElement(
          ButtonGroup,
          null,
          React.createElement(
            StaggeredMotion,
            {
              defaultStyles: [{ x: -45, o: 0 }],
              styles: function styles(prevInterpolatedStyles) {
                return prevInterpolatedStyles.map(function (_, i) {
                  return i === prevInterpolatedStyles.length - 1 ? {
                    x: spring(_this2.state.active ? 0 : -45, { stiffness: 330, damping: 20 }),
                    o: spring(_this2.state.active ? 1 : 0, { stiffness: 330, damping: 20 })
                  } : {
                    x: spring(prevInterpolatedStyles[i + 1].x, { stiffness: 330, damping: 20 }),
                    o: spring(prevInterpolatedStyles[i + 1].o, { stiffness: 330, damping: 20 })
                  };
                });
              }
            },
            function (interpolatingStyles) {
              return React.createElement(
                ButtonGroup,
                { className: "alter" },
                interpolatingStyles.map(function (style, i) {
                  return React.createElement(
                    Button,
                    {
                      onClick: _this2.props.onClickOne,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      className: "MenuSide",
                      key: i,
                      style: {
                        position: 'relative',
                        right: style.x,
                        opacity: style.o,
                        pointerEvents: _this2.state.active ? 'auto' : 'none'
                      },
                      id: "one" + [i]
                    },
                    React.createElement(
                      UncontrolledTooltip,
                      { placement: "left", target: "one" + [i], text: tooltipArrayOne[i] },
                      tooltipArrayOne[i]
                    ),
                    React.createElement(Icon, {
                      position: "relative",
                      left: "-4px",
                      size: 20,
                      icon: _this2.props.iconOne
                    }),
                    iconArrayOne[i]
                  );
                })
              );
            }
          ),
          React.createElement(
            Motion,
            {
              defaultStyle: { s: 0.675 },
              style: { s: spring(this.state.active ? 1 : 0.675, { stiffness: 330, damping: 14 }) }
            },
            function (interpolatingStyles) {
              return React.createElement(
                Button,
                {
                  className: _this2.state.active ? 'button--large active red' : 'button--large green',
                  onClick: _this2._onClick,
                  style: {
                    transform: 'scale(' + interpolatingStyles.s + ')'
                  }
                },
                React.createElement("span", { className: _this2.state.active ? 'icon active' : 'icon' })
              );
            }
          ),
          React.createElement(
            StaggeredMotion,
            {
              defaultStyles: [{ x: -45, o: 0 }],
              styles: function styles(prevInterpolatedStyles) {
                return prevInterpolatedStyles.map(function (_, i) {
                  return i === 0 ? {
                    x: spring(_this2.state.active ? 0 : -45, { stiffness: 330, damping: 20 }),
                    o: spring(_this2.state.active ? 1 : 0, { stiffness: 330, damping: 20 })
                  } : {
                    x: spring(prevInterpolatedStyles[i - 1].x, { stiffness: 330, damping: 20 }),
                    o: spring(prevInterpolatedStyles[i - 1].o, { stiffness: 330, damping: 20 })
                  };
                });
              }
            },
            function (interpolatingStyles) {
              return React.createElement(
                ButtonGroup,
                null,
                interpolatingStyles.map(function (style, i) {
                  return React.createElement(
                    Button,
                    {
                      onClick: _this2.props.onClickTwo,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      className: "MenuSide",
                      key: i,
                      style: {
                        position: 'relative',
                        left: style.x,
                        opacity: style.o,
                        pointerEvents: _this2.state.active ? 'auto' : 'none'
                      },
                      id: "two" + [i]
                    },
                    React.createElement(
                      UncontrolledTooltip,
                      { placement: "left", target: "two" + [i], text: tooltipArrayTwo[i] },
                      " ",
                      tooltipArrayTwo[i]
                    ),
                    React.createElement(Icon, {
                      position: "relative",
                      left: "-4px",
                      size: 20,
                      icon: _this2.props.iconTwo
                    }),
                    iconArrayTwo[i]
                  );
                })
              );
            }
          )
        )
      );
    }
  }]);

  return MenuSide;
}(Component);

export default MenuSide;